import { setRemoteUrlResolver } from '@nx/angular/mf';

const customRemoteUrlResolver = (remoteName: string) => {
  return `/modules/${remoteName}`;
};

setRemoteUrlResolver(customRemoteUrlResolver);
// eslint-disable-next-line no-console
import('./bootstrap').catch((err) => console.error(err));
